<div class="dialog">
    <h6>Enter OTP</h6>
    <div class="custom-form" [formGroup]="verifyMobileForm">
        <input type="text" formControlName="otp">
        <div class="row mr-0 ml-0 pl-0 mt-2">
            <p>Didn't Receive?</p>&nbsp;&nbsp;&nbsp;
            <a class="pointer" (click)="resendOtp()">Click here to resend</a>
        </div>
    </div>
    <div class="button mt-5">
        <button class="orange mr-3" (click)="cancel()">Cancel</button>
        <button class="white ml-3" (click)="submit()">Save</button>
    </div>
</div>